module.exports = __webpack_public_path__ + "img/liveNum9.c8f78ed0.png";